import React from 'react'

export default function Users({ className, ...props }) {
  return (
    <svg className={`${className} w-8 h-8`} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.5 21V19C17.5 16.7909 15.7091 15 13.5 15H9.5C7.29086 15 5.5 16.7909 5.5 19V21" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5 11C13.7091 11 15.5 9.20914 15.5 7C15.5 4.79086 13.7091 3 11.5 3C9.29086 3 7.5 4.79086 7.5 7C7.5 9.20914 9.29086 11 11.5 11Z" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
